import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "school-header-section" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "school-info"
}
const _hoisted_4 = { class: "school-name" }

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Menu from '../../../api/v2/models/menu'
import { ROUTER_NAME } from '../../router'
import { examState } from '../../stores/exam'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import { LETTER_FORMAT } from '../../utils/constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderLeftMenuWeb',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const router = useRouter()
const route = useRoute()

const drawer = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit('update:modelValue', val)
})

// Keep the "面談" group expanded whenever any /classroom/appointment hash is active.
// Use a writable ref so Vuetify can also toggle it on user click; watch route to re-open.
const openedGroups = ref<string[]>(
  route.path.startsWith('/classroom/appointment') ? ['appointment'] : []
)
watch(() => route.path, (path) => {
  if (path.startsWith('/classroom/appointment') && !openedGroups.value.includes('appointment')) {
    openedGroups.value = [...openedGroups.value, 'appointment']
  }
})

const schoolSetting = computed(() => headerState.schoolSetting)
const user = computed(() => userState.user)
const untestCount = computed(() => examState.listRecommendationExam.untestCount)
const onboardingMode = computed(() => route.meta?.onboardingMode === true)

const navStyle = computed(() => {
  // Sidebar uses fixed dark color like Vuetify 2 dark theme
  // Header uses schoolSetting.navColor separately
  return { backgroundColor: '#212121', color: '#ffffff' }
})

const getVisiable = (type: string) => {
  if (!schoolSetting.value || !schoolSetting.value.classroomMenus) {
    return false
  }
  return schoolSetting.value.classroomMenus.find(item => item.kbn == type)?.visibility
}

const goToHome = () => {
  router.push({
    name: ROUTER_NAME.HOME,
  })
}

const logout = () => {
  // Clear all cart-related data from sessionStorage
  sessionStorage.removeItem('cart')
  sessionStorage.removeItem('checkout_cart')

  window.location.href = '/users/sign_out'
}

const goToPath = (path: string) => {
  window.location.href = path
}

onMounted(() => {
  headerState.getSchoolSetting()
})

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    theme: "dark",
    style: _normalizeStyle(navStyle.value),
    modelValue: drawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
    permanent: drawer.value
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" Header with school avatar and name "),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "school-header-content",
          onClick: goToHome
        }, [
          _createVNode(_component_v_avatar, {
            size: "48",
            class: "school-avatar"
          }, {
            default: _withCtx(() => [
              (schoolSetting.value && schoolSetting.value.imageUrl)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: schoolSetting.value.imageUrl
                  }, null, 8 /* PROPS */, _hoisted_2))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }),
          (schoolSetting.value && schoolSetting.value.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(schoolSetting.value.name), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createCommentVNode(" Onboarding mode: show only onboarding menu item "),
      (onboardingMode.value)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 0,
            class: "pt-0 custom-links-v-list",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                to: "/classroom/on-boarding",
                active: true
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("mdi-home", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode(" オンボーディング ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : (user.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Normal mode: show full menu "),
              _createVNode(_component_v_list, {
                class: "pt-0 custom-links-v-list",
                density: "compact",
                opened: openedGroups.value,
                "onUpdate:opened": _cache[0] || (_cache[0] = ($event: any) => ((openedGroups).value = $event))
              }, {
                default: _withCtx(() => [
                  (schoolSetting.value && schoolSetting.value.useUserDashboard && !user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_HOME'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        to: "/classroom",
                        active: _ctx.$route.path === '/classroom/' || _ctx.$route.path === '/classroom'
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createTextVNode("mdi-home", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_HOME").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (schoolSetting.value && schoolSetting.value.useGoal && !user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_GOAL'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        to: "/classroom/user-goals",
                        active: _ctx.$route.path.startsWith('/classroom/user-goals')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-flag-checkered", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_GOAL").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (schoolSetting.value && schoolSetting.value.useCourseLesson && !user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_COURSE'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        to: "/classroom/my-courses",
                        active: _ctx.$route.path.startsWith('/classroom/my-courses')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createTextVNode("mdi-television", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_COURSE").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (schoolSetting.value && schoolSetting.value.useExam && getVisiable('CLASSROOM_MENU_KBN_TEST'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 3,
                        to: "/classroom/my-exams",
                        active: _ctx.$route.path.startsWith('/classroom/my-exams')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-compass", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_TEST").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (schoolSetting.value && schoolSetting.value.useUserQuestion && !user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_QUESTION'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 4,
                        to: "/classroom/my-questions",
                        active: _ctx.$route.path.startsWith('/classroom/my-questions') || _ctx.$route.path.startsWith('/classroom/questions') || _ctx.$route.path.startsWith('/classroom/my-answer-questions')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("mdi-help-circle-outline", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_QUESTION").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (!user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_ACTIVITY'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 5,
                        to: "/classroom/activities",
                        active: _ctx.$route.path.startsWith('/classroom/activities')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-magnify", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_ACTIVITY").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (!user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_INQUIRY'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 6,
                        to: "/classroom/inquiries",
                        active: _ctx.$route.path.startsWith('/classroom/inquiries')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("mdi-email", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_INQUIRY").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (!user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_ANNOUNCEMENT'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 7,
                        to: "/classroom/infors",
                        active: _ctx.$route.path.startsWith('/classroom/infors')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-bell-outline", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_ANNOUNCEMENT").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (user.value && user.value.isUseSubscription && schoolSetting.value && schoolSetting.value.usePremiumService && user.value.subscriptions.length > 0 && !user.value.isGuestExamOnly && getVisiable('CLASSROOM_MENU_KBN_SUBSCRIPTION'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 8,
                        to: "/classroom/subscription",
                        active: _ctx.$route.path.startsWith('/classroom/subscription')
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode("mdi-currency-usd", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_SUBSCRIPTION").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["active"]))
                    : _createCommentVNode("v-if", true),
                  (getVisiable('CLASSROOM_MENU_KBN_MEETING') && schoolSetting.value && schoolSetting.value.useMeeting)
                    ? (_openBlock(), _createBlock(_component_v_list_group, {
                        key: 9,
                        value: "appointment"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, {
                            active: _ctx.$route.path.startsWith('/classroom/appointment')
                          }), {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                  _createTextVNode("mdi-calendar", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode(" 面談 ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 16 /* FULL_PROPS */, ["active"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            to: "/classroom/appointment#/dashboard",
                            active: _ctx.$route.path.startsWith('/classroom/appointment') && (!_ctx.$route.hash || _ctx.$route.hash.includes('/dashboard'))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode(" ダッシュボード ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"]),
                          _createVNode(_component_v_list_item, {
                            to: "/classroom/appointment#/teachers",
                            active: _ctx.$route.hash.includes('/teachers')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createTextVNode(" 先生を探す ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"]),
                          _createVNode(_component_v_list_item, {
                            to: "/classroom/appointment#/events",
                            active: _ctx.$route.hash.includes('/events')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createTextVNode(" 予約一覧 ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"]),
                          _createVNode(_component_v_list_item, {
                            to: "/classroom/appointment#/tickets",
                            active: _ctx.$route.hash.includes('/tickets')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createTextVNode(" 面談チケット ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"]),
                          _createVNode(_component_v_list_item, {
                            to: "/classroom/appointment#/histories",
                            active: _ctx.$route.hash.includes('/histories')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createTextVNode(" 過去の面談 ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["active"])
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  _createCommentVNode(" 受講生向けマニュアル（/manuals）。スクールで「受講生向けマニュアルを表示する」がONのときだけ "),
                  (schoolSetting.value && schoolSetting.value.useStudentManual)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 10,
                        href: "/manuals",
                        target: "_blank"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createTextVNode("mdi-help-circle-outline", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                              _createTextVNode(" 使い方 ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (getVisiable('CLASSROOM_MENU_KBN_LOGOUT'))
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 11,
                        onClick: logout
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("mdi-logout", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(schoolSetting.value.classroomMenus.find(item => item.kbn == "CLASSROOM_MENU_KBN_LOGOUT").viewName), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["opened"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
          : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["style", "modelValue", "permanent"]))
}
}

})